// ===== COUNTDOWN TIMER =====
// Counts down to a custom drop date or next Friday at 12pm EST
function getDropTarget() {
  // Check for custom drop date set in theme editor
  if (window._vaultDropDate) {
    const custom = new Date(window._vaultDropDate.replace(' ', 'T') + ':00-05:00');
    if (!isNaN(custom.getTime())) return custom;
  }
  // Fallback: next Friday at 12pm EST
  const now = new Date();
  const est = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
  const day = est.getDay();
  let daysUntilFriday = (5 - day + 7) % 7;
  if (daysUntilFriday === 0) {
    const noon = new Date(est);
    noon.setHours(12, 0, 0, 0);
    if (est >= noon) daysUntilFriday = 7;
  }
  const target = new Date(est);
  target.setDate(target.getDate() + daysUntilFriday);
  target.setHours(12, 0, 0, 0);
  return target;
}

function updateCountdown() {
  const daysEl = document.getElementById('days');
  if (!daysEl) return;

  const now = new Date();
  const target = getDropTarget();
  const diff = target - now;

  if (diff <= 0) {
    daysEl.textContent = '00';
    document.getElementById('hours').textContent = '00';
    document.getElementById('minutes').textContent = '00';
    document.getElementById('seconds').textContent = '00';
    return;
  }

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  daysEl.textContent = String(days).padStart(2, '0');
  document.getElementById('hours').textContent = String(hours).padStart(2, '0');
  document.getElementById('minutes').textContent = String(minutes).padStart(2, '0');
  document.getElementById('seconds').textContent = String(seconds).padStart(2, '0');
}

// Only start countdown if elements exist
if (document.getElementById('days')) {
  setInterval(updateCountdown, 1000);
  updateCountdown();
}

// ===== SCROLL ANIMATIONS =====
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.fade-in, .story-page-text, .story-page-emphasis, .story-page-signature, .story-page-value').forEach(el => observer.observe(el));

// ===== NAVBAR SCROLL EFFECT =====
const mainNav = document.getElementById('mainNav');
if (mainNav) {
  window.addEventListener('scroll', () => {
    mainNav.classList.toggle('scrolled', window.scrollY > 20);
  });
}

// ===== MOBILE NAV TOGGLE =====
const navToggle = document.getElementById('navToggle');
const navLinks = document.getElementById('navLinks');
if (navToggle && navLinks) {
  navToggle.addEventListener('click', () => {
    navLinks.classList.toggle('open');
  });
}

// ===== SMOOTH SCROLL FOR ANCHOR LINKS =====
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const href = a.getAttribute('href');
    if (href === '#') return;
    const target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (navLinks) navLinks.classList.remove('open');
    }
  });
});

// ===== SHOP FILTERS =====
document.querySelectorAll('.filter-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const filter = btn.dataset.filter;
    document.querySelectorAll('.drop-card[data-category]').forEach(card => {
      if (filter === 'all' || card.dataset.category === filter) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  });
});
